export default {
  items: [
    {
      moduleCode: 'BCM',
      screenCode: 'BCMFRM179',
      name: 'Frequently Asked Questions',
      url: '/BCMFAQ/FAQ',
      icon: 'fa fa-comment-o'
    },

    {
      moduleCode: 'BCM',
      screenCode: 'BCMFRM180',
      name: 'Setup Frequently Asked Questions',
      url: '/BCMFAQ/FAQAdminList',
      icon: 'fa fa-commenting-o'
    },
  ],
};
